<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <el-button
          v-if="backRole('PM_1')"
          type="primary"
          @click="startCreate()"
          size="mini"
          >项目申请</el-button
        >
      </div>
      <label class="label-name">所属公司：</label>
      <el-select
        size="small"
        :disabled="noSelectOrganization"
        class="organization-select"
        v-model="form.depId"
        placeholder="请选择所属公司"
      >
        <el-option
          v-for="item in organizationListData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="list-title" style="padding: 5px 10px 8px; background: #f8f8f8">
      <!-- 条件搜索 -->
      <h3
        class="title"
        style="float: none; border-bottom: 1px #ccc solid; margin-bottom: 5px"
      >
        条件搜索
        <span class="tip" style="font-size: 12px"
          >（搜索条件为选填, 然后点击搜索按钮进行搜索）</span
        >
      </h3>
      <section style="font-size: 12px">
        <div class="filter-item" style="margin-bottom: 5px">
          <label>项目状态：</label>
          <el-select size="mini" v-model="filterStatus" placeholder="请选择">
            <el-option
              v-for="item in statusArr"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <label class="label-name ml5px">项目编号：</label>
          <span style="width: 210px; display: inline-block">
            <el-input
              size="mini"
              type="number"
              v-model="form.number"
            ></el-input>
          </span>

          <label class="label-name ml5px">项目负责人：</label>
          <span style="width: 160px; display: inline-block">
            <el-input size="mini" type="" v-model="form.leader"></el-input>
          </span>
        </div>
        <div class="filter-item" style="margin-bottom: 5px">
          <label>项目组：</label>
          <el-select size="mini" v-model="teamId" placeholder="请选择">
            <el-option
              v-for="item in teamArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <label class="label-name ml5px">项目名称：</label>
          <span style="width: 420px; display: inline-block">
            <el-input size="mini" type="" v-model="form.name"></el-input>
          </span>

          <el-button
            type="success"
            @click="getFilterData()"
            style="margin-left: 5px"
            size="mini"
            >搜索筛选结果</el-button
          >
          <el-button
            type="primary"
            @click="resetFilterData()"
            style="margin-left: 5px"
            size="mini"
            >重置</el-button
          >
        </div>
      </section>
    </div>

    <el-table
      :data="paginationData"
      :span-method="objectSpanMethod"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column prop="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="number" label="项目编号" width="100px">
      </el-table-column>
      <el-table-column label="项目名称" width="280px">
        <template slot-scope="scope">
          <span v-if="scope.row.ctype" class="title-z">{{
            scope.row.ctype
          }}</span>

          <router-link
            class="table-link"
            :class="scope.row.status == '已废弃' ? 'table-link-delete' : ''"
            target="_blank"
            :to="'/Project/Detail/' + scope.row.id"
            >{{ scope.row.name }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="deptName"
        v-if="form.depId === 0"
        label="所属公司"
        width="180px"
      >
      </el-table-column>
      <el-table-column prop="htzj" label="合同金额(元)"> </el-table-column>
      <!-- <el-table-column prop="team.name" label="所属项目组">
      </el-table-column> -->
      <el-table-column prop="status" label="项目状态"> </el-table-column>

      <el-table-column label="项目负责人" width="150px">
        <template slot-scope="scope">
          <user-info :userData="scope.row.leader"></user-info>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">
          <router-link target="_blank" :to="'/Project/Detail/' + scope.row.id">
            <el-button plain size="mini">详情</el-button>
          </router-link>
          <el-button
            v-if="
              scope.row.status == '申请中' && scope.row.leader.id == userData.id
            "
            type="danger"
            plain
            size="mini"
            @click="projectDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-left: -5px"
      v-if="form.pageTotal > form.pageSize"
      class="list-pagination"
      background
      :page-size="form.pageSize"
      :pager-count="9"
      :current-page="form.page + 1"
      layout="pager"
      :total="form.pageTotal"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";

import UserInfo from "@/components/UserInfo";
import Role from "@/Mixins/role";
export default {
  components: {
    UserInfo,
  },
  mixins: [Role],
  computed: {
    ...mapState({
      organization: (state) => state.main.organization,
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      organizationListData: [],
      noSelectOrganization: true,
      // depId: '',

      // 列表
      loading: true,
      pageSize: 20,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],

      form: {
        page: 0,
        pageSize: 22,
        depId: "",
        leader: "",
        name: "",
        number: "",
        status: "",
        teamId: "",
      },

      // 筛选搜索
      filterKey: "",
      teamId: 0,
      teamArr: [],
      filterStatus: "全部",
      statusArr: [
        "全部",
        "申请中",
        "申请完成",
        "立项完成",
        "招标中",
        "招标完成",
        "签订合同中",
        "实施中",
        "已完成",
      ],
    };
  },
  mounted() {
    // console.log(this.organization.length > 0)

    this.organizationListData.push({
      id: 0,
      name: "集团所有公司",
      depId: 0,
    });
    let _or =
      this.organization.length > 0 ? this.organization[0].childDepts : [];
    this.organizationListData = this.organizationListData.concat(_or);

    this.form.depId = this.userData.secDepIds.split(",")[0] / 1;

    if (this.form.depId == "7" || this.backRole("SYSTEM_1")) {
      this.noSelectOrganization = false;
      this.form.depId = 0;
    }

    // 获取项目组
    this.getTeam();
  },
  methods: {
    // 合并行列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.rowspan != undefined) {
          if (row.rowspan > 0) {
            return [row.rowspan + 1, 1];
          }
        } else {
          return [0, 0];
        }
      }
    },
    // 获取项目组
    getTeam() {
      ajax.post("/gc/project/team/list", "", (res) => {
        this.teamArr = [
          {
            id: 0,
            name: "全部",
          },
        ];
        this.teamArr = this.teamArr.concat(res.vo.array);
      });
    },
    // projectDetail(row) {
    //   this.$router.push("/Project/Detail/" + row.id)
    // },
    projectDelete(row) {
      this.$confirm("此操作将永久删除该工程项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ajax.post("/gc/project/del/" + row.id, "", (res) => {
            this.$message.error("删除项目成功");
            // 重新获取列表
            this.getLists();
          });
        })
        .catch(() => {});
    },
    startCreate() {
      this.$router.push("/Project/Create");
    },
    // 当前页
    handleCurrentChange(val) {
      this.form.page = val - 1;
      this.getLists();
    },

    // 重置
    resetFilterData() {
      this.form.leader = "";
      this.form.name = "";
      this.form.status = "";
      this.form.number = "";
      this.form.teamId = "";
      this.form.page = 0;
      this.filterStatus == "全部";
      this.teamId = 0;

      // 获取符合条件的列表
      this.getLists();
    },
    // 搜索筛选新闻数据
    getFilterData() {
      this.form.page = 0;
      this.form.status = this.filterStatus == "全部" ? "" : this.filterStatus;
      this.form.teamId = this.teamId == "0" ? "" : this.teamId;

      this.getLists();
    },
    // 分页筛选数据
    getPaginationData() {
      // 分页筛选
      let paginationData = this.filterData;

      // 拆分子项目
      this.paginationData = [];
      for (var i = 0; i < paginationData.length; i++) {
        let _item = paginationData[i];
        _item.rowspan = _item.childs.length;
        _item.index = i + 1;
        // push进去父项目
        this.paginationData.push(_item);

        if (_item.rowspan > 0) {
          // console.log(_item.rowspan)
          // push进去子项目
          for (var j = 0; j < _item.childs.length; j++) {
            // _item.childs[j].rowspan = 0
            this.paginationData.push(_item.childs[j]);
          }
        }
      }
    },
    // 获取列表
    getLists() {
      this.loading = true;
      ajax.get("/gc/project/A/list", this.form, (res) => {
        this.loading = false;
        this.filterData = this.listData = res.vo.list;
        this.form.pageTotal = res.vo.size;
        this.getPaginationData();
      });
    },
  },
  watch: {
    "form.depId"() {
      this.getLists();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/aList.vue